import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import { computed, ref, watch } from 'vue'
import { useTilatunnusDuplicates } from '@/methods/tilatunnusDuplicatesComposables'
import { ElMessage } from 'element-plus'
import { Warning } from '@element-plus/icons-vue'
import ComTooltip from '@/components/common/ComTooltip.vue'


const __default__ = {
    name: 'ComDuplicatesWarning',
    inheritAttrs: false
}

interface Props {
    hankeId: number
}


export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
    hankeId: {}
  },
  setup(__props: any) {

const props = __props
const hankeId = computed(() => props.hankeId)
const drawerVisible = ref(false)

const { duplicates, hasDuplicates, loading, error } = useTilatunnusDuplicates(hankeId)

const openDrawer = () => {
    drawerVisible.value = true
}

watch(error, (value) => {
    if (value) {
        ElMessage.error('Virhe duplikaattien haussa!')
    }
})


return (_ctx: any,_cache: any) => {
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_space = _resolveComponent("el-space")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_drawer = _resolveComponent("el-drawer")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_unref(hasDuplicates))
      ? (_openBlock(), _createBlock(_component_el_button, {
          key: 0,
          type: "warning",
          size: "small",
          circle: "",
          onClick: openDrawer
        }, {
          default: _withCtx(() => [
            _createVNode(ComTooltip, { content: "Päällekkäisiä tilatunnuksia" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_icon, null, {
                  default: _withCtx(() => [
                    _createVNode(_unref(Warning))
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (_unref(hasDuplicates))
      ? (_openBlock(), _createBlock(_component_el_drawer, {
          key: 1,
          modelValue: drawerVisible.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((drawerVisible).value = $event)),
          title: "Päällekkäiset tilatunnukset",
          direction: "rtl",
          size: "50%",
          "append-to-body": true
        }, {
          default: _withCtx(() => [
            (!_unref(error))
              ? (_openBlock(), _createBlock(_component_el_table, {
                  key: 0,
                  data: _unref(duplicates)?.duplicates,
                  stripe: ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_table_column, {
                      prop: "tilatunnus",
                      label: "Tilatunnus",
                      width: "150"
                    }, {
                      default: _withCtx((scope) => [
                        _createVNode(_component_el_tag, { type: "primary" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(scope.row.tilatunnus), 1)
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_table_column, {
                      prop: "count",
                      label: "Määrä",
                      width: "100"
                    }, {
                      default: _withCtx((scope) => [
                        _createTextVNode(_toDisplayString(scope.row.count), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_table_column, {
                      label: "Tila ID:t",
                      "min-width": "200"
                    }, {
                      default: _withCtx((scope) => [
                        _createVNode(_component_el_space, { wrap: "" }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(scope.row.tilaIds, (tilaId) => {
                              return (_openBlock(), _createBlock(_component_el_tag, {
                                key: tilaId,
                                type: "info",
                                size: "small"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(tilaId), 1)
                                ]),
                                _: 2
                              }, 1024))
                            }), 128))
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["data"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["modelValue"]))
      : _createCommentVNode("", true)
  ]))
}
}

})